<div class="layout-ParentDiv">
    <div class="layout-dashboard">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Overview </h4>
            </div>
            <div class="rightDiv">
            </div>
        </div>
        <div class="mainDivBody">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="MetricsSummaryCard">
                        <div class="p-col-12 headerTitle">
                            <h4>Metrics Summary</h4>
                        </div>
                        <div class="p-grid m-0 cardList">
                            <div class="p-col-12 d-flex columsGap">
                                <div class="p-col">
                                    <div class="overview-info noneLink">
                                        <div class="cardheader">
                                            <div class="leftIcon">
                                                <img src="../../../assets/images/backend-image/dashboard/card1.svg"
                                                    alt="">
                                            </div>
                                            <div class="rightIcon">
                                                <div class="icon">
                                                    <img src="../../../assets/images/backend-image/dashboard/topicon.svg"
                                                        alt="">
                                                    <span>{{matricsSummaryData?.totalRevenue.percentage}}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <h6> Total Revenue </h6>
                                        <h1>₹{{formatAmount(matricsSummaryData?.totalRevenue.value)}}</h1>
                                    </div>
                                </div>
                                <div class="p-col">
                                    <div class="overview-info noneLink">
                                        <div class="cardheader">
                                            <div class="leftIcon">
                                                <img src="../../../assets/images/backend-image/dashboard/card2.svg"
                                                    alt="">
                                            </div>
                                            <div class="rightIcon">
                                                <div class="icon">
                                                    <img src="../../../assets/images/backend-image/dashboard/topicon.svg"
                                                        alt="">
                                                    <span>{{matricsSummaryData?.activeUsers.percentage}}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <h6> Active Users </h6>
                                        <h1>{{formatNumberWithComma(matricsSummaryData?.activeUsers.value)}}</h1>
                                    </div>
                                </div>
                                <div class="p-col">
                                    <div class="overview-info noneLink">
                                        <div class="cardheader">
                                            <div class="leftIcon">
                                                <img src="../../../assets/images/backend-image/dashboard/card3.svg"
                                                    alt="">
                                            </div>
                                            <div class="rightIcon">
                                                <div class="icon">
                                                    <img src="../../../assets/images/backend-image/dashboard/topicon.svg"
                                                        alt="">
                                                    <span>{{matricsSummaryData?.standardAcademies.percentage}}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <h6>Standard Academies</h6>
                                        <h1>{{formatNumberWithComma(matricsSummaryData?.standardAcademies.value)}}</h1>
                                    </div>
                                </div>
                                <div class="p-col">
                                    <div class="overview-info noneLink">
                                        <div class="cardheader">
                                            <div class="leftIcon">
                                                <img src="../../../assets/images/backend-image/dashboard/card4.svg"
                                                    alt="">
                                            </div>
                                            <div class="rightIcon">
                                                <div class="icon">
                                                    <img src="../../../assets/images/backend-image/dashboard/topicon.svg"
                                                        alt="">
                                                    <span>{{matricsSummaryData?.premiumAcademies.percentage}}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <h6> Premium Academies </h6>
                                        <h1>{{formatNumberWithComma(matricsSummaryData?.premiumAcademies.value)}}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                  <div class="p-col-12 pendingApprovalDiv">
                    <div class="greyCard">
                        <div class="cardHeader-collaped">
                            <div class="leftDiv">
                                <button class="btn btn-primary" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#ApprovalCollapese" aria-expanded="false"
                                    aria-controls="ApprovalCollapese" (click)="isOpen = !isOpen">
                                    Pending Approvals <span [class.rotate]="isOpen"><img src="../../../assets/images/backend-image/dashboard/arrowIcon.svg" alt=""></span>
                                </button>
                            </div>
                            <div class="rightDiv">
                                <div class="dropdown">
                                </div>
                            </div>
                        </div>
                        <div class="gerycardMainbody">
                            <div class="collapse show" id="ApprovalCollapese">
                                <ul class="staticList">
                                    <li>
                                        <div class="card orangeCard Link" (click)="onUserVideos()">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p1.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved Player Videos </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedPlayerVideos)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card redCard Link" (click)="onDeleteRequest()">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p2.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6>Delete Account Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.deleteAccountRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card orangeCard Link" (click)="onUserLink('coach')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p3.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved Coaches </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedCoaches)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card purpleCard Link"  (click)="onUserLink('proplayer')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p4.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved Pro Player </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedProPlayer)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card blueCard noneLink">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p6.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Approved Coaches </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.approvedCoaches)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card purpleCard Link " (click)="onPassportVerificationPageNavigation()">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p5.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Pending Passport Verification </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.pendingTournamentPassportVerification)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card blueCard  Link" (click)="onUserKycList()">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p6.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> User KYC Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.userKYCRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card orangeCard Link" (click)="tennisTournaments('academylist')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p3.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved Tournaments </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedTournaments)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card orangeCard Link" (click)="pickleBallTournaments('academylist')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p3.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved PickleBall Tournaments </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedPickleballTournaments)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card orangeCard Link" (click)="padelTournaments('academylist')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p3.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Unapproved Padel Tournaments </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.unapprovedPadelTournaments)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-33List">
                                        <div class="card greenCard Link" (click)="onWalletRedemption()">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p8.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Wallet Redemption </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.walletRedemption)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- <li class="w-33List">
                                        <div class="card redCard Link" (click)="tennisTournaments('deleteTournamentRequest')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p2.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Delete Tournament Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.deleteTournamentRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li> -->
                                    <!-- <li class="w-33List">
                                        <div class="card redCard Link" (click)="tennisTournaments('deleteTournamentRequest')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p2.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Delete PickleBall Tournament Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.deleteTournamentRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-33List">
                                        <div class="card redCard Link" (click)="tennisTournaments('deleteTournamentRequest')">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p2.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Delete Padel Tournament Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.deleteTournamentRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li> -->
                                    <li class="w-33List">
                                        <div class="card greenCard noneLink">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/p9.svg" alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Rewards Request </h6>
                                                <h1>{{formatNumberWithComma(pendingApprovalsData?.rewardsRequest)}}</h1>
                                            </div>
                                        </div>
                                    </li> 
                                </ul> 
                            </div>
                        </div> 
                    </div> 
                </div>
                <div class="p-col-12 p-pt-0">
                    <div class="greyCard">
                        <div class="cardHeader-collaped">
                            <div class="leftDiv">
                                <button class="btn btn-primary" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#StatisticsCollapese" aria-expanded="false"
                                    aria-controls="StatisticsCollapese" (click)="isOpen2 = !isOpen2">
                                    Statistics <span [class.rotate]="isOpen2"><img src="../../../assets/images/backend-image/dashboard/arrowIcon.svg" alt=""></span>
                                </button>
                            </div>
                            <div class="rightDiv">
                                <div class="dropdown">
                                    <p-dropdown appendTo="body" #pDropDownId [options]="periodOption"
										(onChange)="changeStatisticsPeriod($event.value)" styleClass="p-column-filter">
                                        <ng-template let-option pTemplate="item">
                                            <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="gerycardMainbody">
                            <div class="collapse show" id="StatisticsCollapese">
                                <ul class="staticList">
                                    <li>
                                        <div class="card greenCard noneLink"  >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s1.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/backend-image/dashboard/s1arrow.svg"
                                                                alt="">
                                                            <span>{{statisticsData?.registeredUsers.percentage}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h6> Registered Users </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.registeredUsers.value)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card blueCard noneLink" >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s2.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/backend-image/dashboard/s2arrow.svg"
                                                                alt="">
                                                            <span>{{statisticsData?.playstoreDownloads.percentage}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h6> Playstore Downloads </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.playstoreDownloads.value)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card purpleCard noneLink " >
                                            <div class="overview-info ">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s3.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/backend-image/dashboard/s3arrow.svg"
                                                                alt="">
                                                            <span>{{statisticsData?.appstoreDownloads.percentage}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h6> App Store Downloads </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.appstoreDownloads.value)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card greenCard noneLink" >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s4.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/backend-image/dashboard/s4arrow.svg"
                                                                alt="">
                                                            <span>{{statisticsData?.newRegistrations.percentage}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h6> New Registrationss </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.newRegistrations.value)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card greenCard noneLink "  >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s5.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Earnings on Tournaments </h6>
                                                <h1>₹{{formatAmount(statisticsData?.earningsOnTournaments)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card blueCard noneLink " >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s6.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Earnings on Contest </h6>
                                                <h1>₹{{formatAmount(statisticsData?.earningsOnContests)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card purpleCard noneLink">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s7.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Earnings on Court Bookings </h6>
                                                <h1>₹{{formatAmount(statisticsData?.earningsOnCourtsBookings)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card orangeCard noneLink">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s8.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Earnings on FAP </h6>
                                                <h1>₹{{formatAmount(statisticsData?.earningsOnFaps)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50List">
                                        <div class="card purpleCard noneLink"  >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s9.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                    </div>
                                                </div>
                                                <h6> Total Academies </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.totalAcademies)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50List">
                                        <div class="card greenCard noneLink" >
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="leftIcon">
                                                        <img src="../../../assets/images/backend-image/dashboard/s10.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="rightIcon">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/backend-image/dashboard/s4arrow.svg"
                                                                alt="">
                                                            <span>{{statisticsData?.tournamentsTillDate.percentage}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h6> Tournaments till Date </h6>
                                                <h1>{{formatNumberWithComma(statisticsData?.tournamentsTillDate.value)}}</h1>
                                            </div>
                                        </div>
                                    </li>
                                </ul> 
                            </div>
                        </div>
                    </div>
                </div>
              
                <div class="p-col-12 p-pt-0">
                    <div class="greyCard">
                        <div class="cardHeader-collaped">
                            <div class="leftDiv">
                                <button class="btn btn-primary" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#GraphsCollaped" aria-expanded="false"
                                    aria-controls="GraphsCollaped" (click)="isOpen2 = !isOpen2">
                                    Graphs & Charts <span [class.rotate]="isOpen2"><img src="../../../assets/images/backend-image/dashboard/arrowIcon.svg" alt=""></span>
                                </button>
                            </div>
                            <div class="rightDiv">
                            </div>
                        </div>
                        <div class="gerycardMainbody">
                            <div class="collapse show" id="GraphsCollaped">
                                <ul class="graphCardList">
                                    <li>
                                        <div class="card greenCard ">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="lefttitle">
                                                        <h5>Earnings Breakdown</h5>
                                                        <p>Revenue by category</p>
                                                    </div>
                                                    <div class="rightTitle">
                                                        <p-dropdown appendTo="body" #pDropDownId [options]="periodOption"
                                                            (onChange)="changeEarningPeriod($event.value)" styleClass="p-column-filter">
                                                            <ng-template let-option pTemplate="item">
                                                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                                            </ng-template>
                                                        </p-dropdown>
                                                    </div>
                                                </div>
                                                <div class="chartDiv">
                                                    <ng-container *ngIf="!isEarningChartDataEmpty(); else noEarningData">
                                                        <p-chart type="bar" [data]="earningChartData"
                                                            [options]="earningChartOptions" [height]="232">
                                                        </p-chart>
                                                    </ng-container>
                                                    <ng-template #noEarningData>
                                                        <div class="no-data-message" style="text-align:center;padding:40px 0;color:#888;font-size:18px;">
                                                            No data available
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card greenCard ">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="lefttitle">
                                                        <h5>Academy Distribution</h5>
                                                        <p>Premium vs Standard academies</p>
                                                    </div>
                                                    <div class="rightTitle">
                                                        <p-dropdown appendTo="body" #pDropDownId [options]="periodOption"
                                                            (onChange)="changeAcademyDistributionPeriod($event.value)" styleClass="p-column-filter">
                                                            <ng-template let-option pTemplate="item">
                                                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                                            </ng-template>
                                                        </p-dropdown>
                                                    </div>
                                                </div>
                                                <div class="chartDiv">
                                                    <ng-container *ngIf="!isAcademyChartDataEmpty(); else noAcademyData">
                                                        <p-chart type="doughnut" [data]="academyChartData"
                                                            [options]="academyChartOptions" [height]="232">
                                                        </p-chart>
                                                    </ng-container>
                                                    <ng-template #noAcademyData>
                                                        <div class="no-data-message" style="text-align:center;padding:40px 0;color:#888;font-size:18px;">
                                                            No data available
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card greenCard ">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="lefttitle">
                                                        <h5>New Registrations Trend</h5>
                                                        <p>Daily registrations this week</p>
                                                    </div>
                                                    <div class="rightTitle">
                                                        <p-dropdown appendTo="body" #pDropDownId [options]="periodOption"
                                                            (onChange)="changeNewRegistrationTrendPeriod($event.value)" styleClass="p-column-filter">
                                                            <ng-template let-option pTemplate="item">
                                                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                                            </ng-template>
                                                        </p-dropdown>
                                                    </div>
                                                </div>
                                                <div class="chartDiv">
                                                    <p-chart type="line" [data]="chart2" [options]="chartOptions2"
                                                        [responsive]="true" [height]="232"></p-chart>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card greenCard ">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="lefttitle">
                                                        <h5>App Downloads</h5>
                                                        <p>Monthly comparison</p>
                                                    </div>
                                                    <div class="rightTitle">
                                                        <p-dropdown appendTo="body" #pDropDownId [options]="periodOption"
                                                            (onChange)="changeAppDownloadsPeriod($event.value)" styleClass="p-column-filter">
                                                            <ng-template let-option pTemplate="item">
                                                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                                            </ng-template>
                                                        </p-dropdown>
                                                    </div>
                                                </div>
                                                <div class="chartDiv">
                                                    <p-chart type="bar" [data]="monthlyChartData"
                                                        [options]="monthlyChartOptions" [responsive]="true"
                                                        [height]="232"></p-chart>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-100List">
                                        <div class="card greenCard ">
                                            <div class="overview-info">
                                                <div class="cardheader">
                                                    <div class="lefttitle">
                                                        <h5>Subscribed Users</h5>
                                                        <p>Breakdown by subscription period</p>
                                                    </div>
                                                    <div class="rightTitle">
                                                        <div class="totalDiv">
                                                            <div class="iconRound"></div>
                                                            <div class="totalText">
                                                                <p>Total: {{formatNumberWithComma(subscribedUsersData?.totalSubscribers)}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="chartDiv">
                                                    <ng-container *ngIf="!isSubscribedUsersDataEmpty(); else noSubscribedUsersData">
                                                        <p-chart type="bar" [data]="dualAxisChartData"
                                                            [options]="dualAxisChartOptions" [height]="300">
                                                        </p-chart>
                                                    </ng-container>
                                                    <ng-template #noSubscribedUsersData>
                                                        <div class="no-data-message" style="text-align:center;padding:40px 0;color:#888;font-size:18px;">
                                                            No data available
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                            <div class="planDiv">
                                                <ul class="planList">
                                                    <li class="greenPlane">
                                                        <div class="mainPlanBody">
                                                            <div class="planHeader">
                                                                <h5>3 Months Plan</h5>
                                                            </div>
                                                            <div class="planBody">
                                                                <h2>{{formatNumberWithComma(subscribedUsersData?.breakdown[0]?.subscribers)}}</h2>
                                                            </div>
                                                            <div class="planFooter">
                                                                <p>₹{{formatAmount(subscribedUsersData?.breakdown[0]?.revenue)}} Revenue</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="BluePlane">
                                                        <div class="mainPlanBody">
                                                            <div class="planHeader">
                                                                <h5>6 Months Plan</h5>
                                                            </div>
                                                            <div class="planBody">
                                                                <h2>{{formatNumberWithComma(subscribedUsersData?.breakdown[1]?.subscribers)}}</h2>
                                                            </div>
                                                            <div class="planFooter">
                                                                <p>₹{{formatAmount(subscribedUsersData?.breakdown[1]?.revenue)}} Revenue</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="purplePlane">
                                                        <div class="mainPlanBody">
                                                            <div class="planHeader">
                                                                <h5>12 Months Plan</h5>
                                                            </div>
                                                            <div class="planBody">
                                                                <h2>{{formatNumberWithComma(subscribedUsersData?.breakdown[2]?.subscribers)}}</h2>
                                                            </div>
                                                            <div class="planFooter">
                                                                <p>₹{{formatAmount(subscribedUsersData?.breakdown[2]?.revenue)}} Revenue</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li> 
                                </ul> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-col-12 p-pt-0 tournamentCard">
                    <div class="greyCard">
                        <div class="torunamentDiv">
                            <div class="tournamentHeader">
                                <div class="left">
                                    <h4>Tournaments Overview</h4>
                                    <p>Active and upcoming tournaments</p>
                                </div>
                                <div class="right">
                                    <div class="buttonsDiv">
                                        <button class="borderBtn" routerLink="/manage/academies">
                                            All Tournaments
                                        </button>
                                        <button class="addBtn" routerLink="/manage/academies">
                                            + Add Tournament
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="tournamentBody">
                                <p-table [value]="tournamentsOverviewData" [paginator]="false" [rows]="10" styleClass="p-datatable-gridlines p-datatable-striped p-datatable">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th class="tournamentName">
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Tournament Name 
                                                </div>
                                            </th>
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Date
                                                </div>
                                            </th>
                                            <th class="viewBtnTd">
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Location
                                                </div>
                                            </th>
                                            <th class="statusTD">
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Participants 
                                                </div>
                                            </th>
                                            <th pSortableColumn="coins_required">
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Status 
                                                </div>
                                            </th> 
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-tournament>
                                         <tr class="p-selectable-row">
                                            <td class="tournamentName">
                                                <div class="mainTitle">
                                                    <div class="icon">
                                                        <img src="../../../assets/images/backend-image/dashboard/table1.svg" alt="">
                                                    </div>
                                                    <div class="title">
                                                        {{tournament.tournamentName}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="mainTd d-flex align-items-center">
                                                      <div class="icon">
                                                        <img src="../../../assets/images/backend-image/dashboard/table2.svg" alt="">
                                                    </div>
                                                    <div class="title">{{tournament.tournamentStartDate | date:'yyyy-MM-dd'}}</div> 
                                                </div>
                                            </td>
                                            <td class="viewBtnTd">
                                                <div class="mainTd d-flex align-items-center">
                                                      <div class="icon">
                                                        <img src="../../../assets/images/backend-image/dashboard/table3.svg" alt="">
                                                    </div>
                                                    <div class="title">{{tournament.location}}</div> 
                                                </div>
                                            </td>
                                            <td class="statusTD">
                                                  <div class="mainTd d-flex align-items-center">
                                                      <div class="icon">
                                                        <img src="../../../assets/images/backend-image/dashboard/table4.svg" alt="">
                                                    </div>
                                                    <div class="title">{{tournament.participants}}</div> 
                                                </div>
                                            </td>
                                            <td class="statusdiv">
                                               <div class="status upcomingBtn" *ngIf="tournament.status === 'Upcoming'">
                                                Upcoming
                                               </div>
                                               <div class="status liveBtn" *ngIf="tournament.status === 'Live'">
                                                Live
                                               </div>
                                               <div class="status RegistrationBtn" *ngIf="tournament.status === 'Registration Open'">
                                                Registration Open
                                               </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="5">
                                                No data found.
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <!--common body close--> 
    </div>
</div>